import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const Backdrop = styled(motion.div, {
  base: {
    position: 'fixed',
    inset: '0',
    zIndex: '100',
    backgroundColor: 'rgba(26, 19, 48, 0.55)',
    backdropFilter: 'blur(6px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
})

const Card = styled(motion.div, {
  base: {
    width: '100%',
    maxWidth: '520px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 32px 80px -24px rgba(128, 84, 255, 0.42)',
    padding: '28px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const Header = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const Title = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '24px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.4px',
  },
})

const Subtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.5',
  },
})

const Form = styled('form', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const Footer = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
})

const ErrorBanner = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.warmth',
    padding: '10px 14px',
    borderRadius: 'sm',
  },
})

const PreviewCard = styled('div', {
  base: {
    display: 'flex',
    gap: '14px',
    padding: '14px',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'md',
    backgroundColor: 'quickpass.surface',
  },
})

const PreviewImage = styled('div', {
  base: {
    width: '96px',
    height: '96px',
    borderRadius: 'sm',
    backgroundColor: '#E5E0F5',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    flexShrink: '0',
  },
})

const PreviewBody = styled('div', {
  base: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: '0',
  },
})

const PreviewTitle = styled('div', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

const PreviewMeta = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
})

const PreviewBadge = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    paddingX: '8px',
    paddingY: '3px',
    borderRadius: 'pill',
    alignSelf: 'flex-start',
  },
  variants: {
    tone: {
      success: {
        backgroundColor: 'quickpass.success',
        color: 'quickpass.ink',
      },
      partial: {
        backgroundColor: 'quickpass.celebration',
        color: 'quickpass.ink',
      },
      warning: {
        backgroundColor: 'quickpass.warmth',
        color: '#FFFFFF',
      },
    },
  },
})

const ScrapeNote = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    margin: '6px 0 0 0',
    lineHeight: '1.4',
  },
})

export {
  Backdrop,
  Card,
  Header,
  Title,
  Subtitle,
  Form,
  Footer,
  ErrorBanner,
  PreviewCard,
  PreviewImage,
  PreviewBody,
  PreviewTitle,
  PreviewMeta,
  PreviewBadge,
  ScrapeNote,
}
